<template>
  <div class="content_box">
    <div class="inner">
      <global-title v-if="fromPath" :title="$t('menu.liveAcc')"></global-title>
      <div class="switch_btn" v-if="fromPath" @click="switchAccType">
        <img src="@/assets/images/switch_icon.png" alt />
        <span> {{ $t('home.switchAccType') }}</span>
      </div>
      <Card>
        <div class="no_account_display">
          <div class="floater floater_position01">
            <img class="floater_img01" src="@/assets/images/floater01.png" alt />
            {{ $t('menu.promotion') }}
          </div>
          <div class="floater floater_position02">
            Trading Tools
            <img class="floater_img02" src="@/assets/images/floater02.png" alt />
          </div>
          <img class="no_account_img" src="@/assets/images/no_account.png" alt />
        </div>
        <div class="no_account_desc">{{ $t('register.authority.dialog3') }}</div>

        <div class="no_account_btn">
          <router-link :to="registerPath" class="el-button blue_button">
            {{ $t('register.authority.openLiveAcc') }}
          </router-link>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card';
import GlobalTitle from '@/components/global/title';
import { RegisterRoutePath } from '@/router/registerRoutes';

export default {
  components: { Card, GlobalTitle },
  created() {
    this.registerPath = RegisterRoutePath.register;
  },
  computed: {
    fromPath() {
      return this.$store.state.common.fromPath;
    }
  },
  methods: {
    switchAccType() {
      this.$router.push('/homeDemo');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/register/authority.scss';
</style>
